const RECAPTCHA_V3_SCRIPT_ID = 'recaptcha-v3-script';
const RECAPTCHA_V3_SCRIPT_URL = 'https://www.google.com/recaptcha/api.js?render=';

export const RECAPTCHA_V3_ACTIONS = {
  ADD_USER: 'add_user',
  REPORT_EVENT: 'report_event',
  INTEGRATION: 'integration',
  REMOVE_INTEGRATION: 'remove_integration',
  UPDATE_PROGRAM: 'update_program'
};

function getSiteKey() {
  return process.env.VUE_APP_RECAPTCHA_V3_SITE_KEY;
}

export function loadRecaptchaV3Script() {
  return new Promise((resolve, reject) => {
    const siteKey = getSiteKey();

    if (!siteKey) {
      console.warn('[reCAPTCHA v3] Site key not configured (VUE_APP_RECAPTCHA_V3_SITE_KEY).');
      resolve();
      return;
    }

    if (document.getElementById(RECAPTCHA_V3_SCRIPT_ID)) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.id = RECAPTCHA_V3_SCRIPT_ID;
    script.src = `${RECAPTCHA_V3_SCRIPT_URL}${siteKey}`;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = (error) => {
      console.error('[reCAPTCHA v3] Failed to load script:', error);
      reject(error);
    };

    document.head.appendChild(script);
  });
}

export async function executeRecaptchaV3(action) {
  const siteKey = getSiteKey();

  if (!siteKey) {
    console.warn('[reCAPTCHA v3] Site key not configured. Skipping execute.');
    return null;
  }

  if (!window.grecaptcha) {
    console.warn('[reCAPTCHA v3] grecaptcha not available. Skipping execute.');
    return null;
  }

  return new Promise((resolve) => {
    try {
      window.grecaptcha.ready(() => {
        try {
          window.grecaptcha
            .execute(siteKey, { action })
            .then((token) => resolve(token))
            .catch((error) => {
              console.error('[reCAPTCHA v3] Execute failed:', error);
              resolve(null);
            });
        } catch (error) {
          console.error('[reCAPTCHA v3] Execute threw synchronously:', error);
          resolve(null);
        }
      });
    } catch (error) {
      console.error('[reCAPTCHA v3] grecaptcha.ready threw:', error);
      resolve(null);
    }
  });
}
